module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isAnim) ? _c('transition', {
    attrs: {
      "name": "show-footer"
    }
  }, [(_vm.show) ? _c('footer', {
    staticClass: "orange-footer"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAnim) ? _c('footer', {
    staticClass: "orange-footer"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cda3a6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterOrange.vue
// module id = 281
// module chunks = 0